module.exports = __webpack_public_path__ + "img/SFA event 2.84d7cb1d.jpg";